<template>
  <a-config-provider :locale="locale">
    <div style="padding-top: 35px" v-if="isFullScreen"></div>
    <router-view
      class="router-view"
      :class="{ 'min-width-container': $route.path !== '/h5Home' }"
    />
  </a-config-provider>
</template>
<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");
import { defineComponent, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { isMobile } from "@/utils";
export default defineComponent({
  computed: {},
  setup() {
    const router = useRouter();
    const route = useRoute();

    // 判断设备
    const judgeDevice = () => {
      const flag = isMobile();
      if (flag) {
        router.push("/h5Home");
      } else if (!flag && route.path.includes("h5")) {
        router.push("/home");
      }
    };

    // 判断环境
    const judgeProtocal = () => {
      if (process.env.VUE_APP_ENV === "release" && location.href.indexOf("http://") === 0) {
        // 正式环境，http自动跳转https页
        location.href = location.href.replace("http://", "https://");
      }
    };

    onMounted(() => {
      judgeDevice();
      judgeProtocal();
    });

    const locale = zhCN;
    return { locale, dayjs };
  },
});
</script>
<style lang="less">
@import "ant-design-vue/dist/antd.dark.less";

html ::-webkit-scrollbar {
  width: 0;
  height: 0;
}

#app ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

#app ::-webkit-scrollbar-track {
  background: transparent;
}

#app ::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 13.333px;
  background: rgba(255, 255, 255, 0.3);
}

.full-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
}
</style>
